import { render } from "./Peek.vue?vue&type=template&id=2dddec48"
import script from "./Peek.vue?vue&type=script&lang=js"
export * from "./Peek.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__